<style scoped>
i.circle {
  width: 25px;
  height: 25px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  display: block;
  float: left;
  margin-right: 10px;
}

span > span {
  white-space: nowrap;
  padding: 0;
}
</style>

<template>
  <span>
    <span v-if="status === 'X'" class="grey--text lighten-5">
      <i class="circle grey lighten-5"></i>
      cancelled
    </span>
    <span v-else-if="status === 'C'" class="green--text">
      <i class="circle green"></i>
      complete
    </span>
    <span v-else-if="status === 'B'" class="yellow--text">
      <i class="circle yellow"></i>
      partial
    </span>

    <span v-else class="light-blue--text">
      <i class="circle light-blue"></i>
      open
    </span>
  </span>
</template>

<script>
export default {
  props: {
    deliveryStatus: String,
    rejectionStatus: String
  },
  computed: {
    status() {
      return this.rejectionStatus === "C" ? "X" : this.deliveryStatus;
    }
  }
};
</script>
